import BackLink from "./BackLink";

/**
 * LEGAL PHASE 2 §31 — the explicit refusal a guarded route shows instead of a silent redirect.
 *
 * IT SAYS ONLY THAT ACCESS IS REFUSED. No id, no owner, no Field or Legal state and no statement that
 * the record exists — the same discipline the server's own refusals keep. Rendered by `RoleRoute` for
 * routes that opt in; the server still refuses the data behind the page on its own.
 */
export default function AccessDenied({ message = "You do not have permission to access this Legal work." }) {
  return (
    <div className="p-3">
      <div className="alert alert-warning" role="alert">
        <h1 className="h5 mb-2">
          <i className="bi bi-shield-lock me-2" aria-hidden="true" />
          Access denied
        </h1>
        <p className="mb-3">{message}</p>
        <BackLink fallbackTo="/" label="Back" className="btn btn-sm btn-outline-secondary" />
      </div>
    </div>
  );
}
